import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// rem适配
import './flexible';
import Vant from 'vant';
import directive from './directive' // directive
import {deepClone} from "@/utils/ruoyi";

import './permission'
import './styles/index.less'

// CSS 全局变量
import './styles/variables.scss'
import 'vant/lib/index.less';
// 引入element-ui css
import 'element-ui/lib/theme-chalk/index.css'
// 按需引入element-ui组件
import customElement from "@/plugins/element";
import viewItem from "@/components/viewItem/index.vue";
import {Dialog, ImagePreview} from 'vant';
import loading from '@/components/loading';
// 字典
import DictTag from '@/components/DictTag'
// 水印
import UserWatermark from '@/components/UserWatermark'
// 全局挂载水印
Vue.component('UserWatermark', UserWatermark)
Vue.component('DictTag', DictTag)
// 自定义全局loading
const FullScreenLoadingInstance = Vue.extend(loading);
const fullScreenLoading = new FullScreenLoadingInstance();
fullScreenLoading.$mount();
document.body.appendChild(fullScreenLoading.$el);
Vue.prototype.$loading = fullScreenLoading;

Vue.use(Vant);
Vue.use(Dialog);
Vue.use(customElement)
Vue.component('viewItem', viewItem)
Vue.use(directive)

Vue.prototype.$deepCopy = deepClone
Vue.prototype.$imagePreview = ImagePreview
Vue.config.productionTip = false

export default new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
